import React from 'react';
import { Datagrid, TextField, Filter, List, SearchInput } from 'react-admin';

import FullNameField from '../fields/users/FullNameField';
import ColoredBooleanField from '../fields/common/ColoredBooleanField';

const UserFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
);

const UserList = (props: any) => {
    return (
        <List
            {...props}
            filters={<UserFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
            // aside={<UserListAside />}
        >
            <Datagrid optimized rowClick="edit">
                <FullNameField
                    source="name"
                    label="resources.operators.fields.name.full"
                />
                <TextField
                    source="email"
                    label="resources.operators.fields.email"
                />
                <TextField
                    source="phone"
                    label="resources.operators.fields.phone"
                />
                <ColoredBooleanField
                    source="account_enabled"
                    label="resources.operators.fields.account_enabled"
                />
            </Datagrid>
        </List>
    );
};

export default UserList;
